import { z } from 'zod';

/**
 * Where a gameweek sits relative to now: `pre` before its deadline, `live`
 * once the deadline has passed but matches haven't all finished, `post` once
 * they have.
 */
export const GameweekPhaseSchema = z.enum(['pre', 'live', 'post']);
export type GameweekPhase = z.infer<typeof GameweekPhaseSchema>;

/**
 * `deadline` and `phase` are nullable, not defaulted: before any sync has run
 * there is no honest answer, and the frontend must be able to show nothing
 * rather than show a guess. `currentGameweek` is unaffected — it already has
 * an honest fallback of its own (see `FixtureRepository.currentGameweek`).
 */
export const GameweekMeta = z.object({
  currentGameweek: z.number().int(),
  deadline: z.string().nullable(),
  phase: GameweekPhaseSchema.nullable(),
  nextDeadline: z.string().nullable(),
});
export type GameweekMeta = z.infer<typeof GameweekMeta>;
